<template>

    <div class="container">
        <!-- BOTTONI PRIMA DELLA MAPPA -->
        <div class="d-flex flex-wrap justify-content-center my-4 gap-3">
            <button class="btn btn-outline-primary" type="button" data-bs-toggle="collapse"
                    data-bs-target="#sezione-mappa">
                🗺️ Analisi Incidenti 2022-2023 COMUNE DI BARI
            </button>
            <button class="btn btn-outline-primary" type="button" data-bs-toggle="collapse"
                    data-bs-target="#sezione2025">
                📅 Incidenti Notizie BariToday/BariLive - 2025
            </button>
            <button class="btn btn-outline-primary" type="button" data-bs-toggle="collapse"
                    data-bs-target="#sezione2024">
                📅 Incidenti Notizie BariToday/BariLive - 2024
            </button>
            <button class="btn btn-outline-primary" type="button" data-bs-toggle="collapse"
                    data-bs-target="#sezione10anni">
                📊 Incidenti Notizie BariToday/BariLive - Ultimi 10 anni
            </button>
        </div>
    </div>

    <p class="container alert alert-info">
        ⬆️ Clicca sui tasti per visualizzare i dati relativi all'analisi 2022-2023, 2025, 2024 e degli ultimi 10 anni ⬆️
    </p>


    <div v-if="loading" class="loading">
        <div class="loading-text">
            Caricamento...
        </div>
        <p class="spinner-border text-dark" role="status">
            <span class="visually-hidden">Loading...</span>
        </p>
    </div>
    <div v-else>
        <div id="accidentsAccordion">
            <div class="collapse show" id="sezione-mappa" data-bs-parent="#accidentsAccordion">
                <h2> 🏛️ Analisi Incidenti 2022-2023 COMUNE DI BARI</h2>
                <div v-if="mapUrl">
                    <iframe :src="mapUrl" width="100%" height="500px" allowfullscreen></iframe>
                </div>

                <div v-if="top_30_streets_dict" class="table30-container">
                    <h2>🚗 Top 30 strade con più incidenti</h2>
                    <DataTable class="table table-bordered table-hover table-responsive pois-table"
                               :options="this.options_30">
                        <thead>
                        <tr>
                            <th v-for="key in columns_top_30" :key="key">
                                {{ key }}
                            </th>
                            <th v-for="key in filteredTop30Keys" :key="key">
                                {{ key }}
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(data, index) in top_30_streets_dict" :key="index">
                            <td v-for="key in columns_top_30" :key="key">
                                {{ data[key] }}
                            </td>
                            <td v-for="key in filteredTop30Keys" :key="key">
                                <div v-if="isDict(data[key])">
                                    <div v-for="(value, key_1) in data[key]" :key="key_1">
                                        {{ key_1 }}: {{ value }}
                                    </div>
                                </div>
                                <div v-else>
                                    {{ data[key] }}
                                </div>

                            </td>
                        </tr>
                        </tbody>
                    </DataTable>
                </div>
                <p v-else>Non ci sono dati disponibili.</p>
            </div>


            <div v-if="df_current_year_dict" class="collapse" id="sezione2025" data-bs-parent="#accidentsAccordion">
                <div class="card card-body">
                    <div class="table-container">
                        <h2>🚑 Incidenti: dati dell'anno 2025</h2>
                        <div v-for="(rows, category) in df_current_year_dict" :key="category" class="mb-5">
                            <h3 class="text-primary">{{ category.substring(3) }}</h3>
                            <DataTable class="table table-bordered table-hover table-responsive pois-table"
                                       :options="this.options">
                                <thead>
                                <tr>
                                    <th v-for="key in columns" :key="key">
                                        {{ key }}
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(row, index) in rows" :key="index">
                                    <td v-for="key in columns" :key="key">
                                        {{ row[key] }}
                                    </td>
                                </tr>
                                </tbody>
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
            <p v-else>Non ci sono dati disponibili.</p>

            <div v-if="df_last_year_dict" class="collapse" id="sezione2024" data-bs-parent="#accidentsAccordion">
                <div class="card card-body">
                    <div class="table-container">
                        <h2>🚑 Incidenti: dati dell'anno 2024</h2>
                        <div v-for="(rows, category) in df_last_year_dict" :key="category" class="mb-5">
                            <h3 class="text-primary">{{ category.substring(3) }}</h3>
                            <DataTable class="table table-bordered table-hover table-responsive pois-table"
                                       :options="this.options">
                                <thead>
                                <tr>
                                    <th v-for="key in columns" :key="key">
                                        {{ key }}
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(row, index) in rows" :key="index">
                                    <td v-for="key in columns" :key="key">
                                        {{ row[key] }}
                                    </td>
                                </tr>
                                </tbody>
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
            <p v-else>Non ci sono dati disponibili.</p>

            <div v-if="df_10_years_dict" class="collapse" id="sezione10anni" data-bs-parent="#accidentsAccordion">
                <div class="card card-body">
                    <div class="table-container">
                        <h2>🚑 Incidenti: ultimi 10 anni</h2>
                        <div v-for="(rows, category) in df_10_years_dict" :key="category" class="mb-5">
                            <h3 class="text-primary">{{ category.substring(3) }}</h3>
                            <DataTable class="table table-bordered table-hover table-responsive pois-table"
                                       :options="this.options">
                                <thead>
                                <tr>
                                    <th v-for="key in columns" :key="key">
                                        {{ key }}
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(row, index) in rows" :key="index">
                                    <td v-for="key in columns" :key="key">
                                        {{ row[key] }}
                                    </td>
                                </tr>
                                </tbody>
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
            <p v-else>Non ci sono dati disponibili.</p>

        </div>
    </div>
</template>

<script>
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net';
import 'datatables.net-responsive';
import 'datatables.net-select';
import {useHead} from '@vueuse/head';


DataTable.use(DataTablesCore);


export default {
    components: {DataTable},
    setup() {
        useHead({
            title: 'InfoNav - Incidenti'
        });
    },
    data() {
        return {
            df_current_year_dict: [],
            df_10_years_dict: [],
            df_last_year_dict: [],
            top_30_streets_dict: [],
            // mapHtml: null,
            mapUrl: null,
            loading: false,
            options: {
                responsive: true,
                select: false,
                language: {
                    url: 'https://cdn.datatables.net/plug-ins/1.13.1/i18n/it-IT.json'
                },
                order: [[0, 'asc']],
            },
            options_30: {
                responsive: true,
                select: false,
                language: {
                    url: 'https://cdn.datatables.net/plug-ins/1.13.1/i18n/it-IT.json'
                },
                order: [[1, 'desc']],
                scrollX: true,
            },
            columns: ["Posizione", "Strada", "Frequenza incidenti"],
            columns_top_30: ["Strada", "Numero incidenti"]

        }
    },
    methods: {
        async getData() {
            this.loading = true;
            await fetch('/api/accidents/', {
                method: 'GET',
            })
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        throw new Error('Error. Try again.');
                    }
                })
                .then((data) => {
                    this.df_current_year_dict = data['df_current_year_dict']
                    this.df_last_year_dict = data['df_last_year_dict']
                    this.df_10_years_dict = data['df_10_years_dict']
                    this.top_30_streets_dict = data['top_30_streets_dict']
                    // this.mapHtml = data['map_html']
                    this.mapUrl = data['map_url']
                })
                .catch((e) => {
                    console.error('Error fetching data:', e);
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        isDict(value) {
            return typeof value === 'object' && value !== null && !Array.isArray(value);
        }
    },
    mounted() {
        // This function runs as soon as the component is loaded
        this.getData();
        // Initialize DataTable after the component has mounted

    },
    computed: {
        filteredTop30Keys() {
            if (!this.top_30_streets_dict || this.top_30_streets_dict.length === 0) {
                return [];
            }
            return Object.keys(this.top_30_streets_dict[0]).filter(
                key => !this.columns_top_30.includes(key)
            );
        }
    }

}


</script>

<style scoped>
@import '../../../../node_modules/datatables.net-dt';

body {
    background-color: #f8f9fa;
    margin: 0;
    padding: 0;
}

/* Container */
.container {
    margin-top: 20px;
    padding: 0 15px;
    /* Aggiunto padding per migliorare la leggibilità */
}

.table-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
}

.table30-container {
    display: block;
    width: 100%;
    overflow-x: auto;
    margin-top: 30px;
}

/* Table Styling */
.table th,
.table td {
    text-align: center;
    vertical-align: middle;
}

.table thead th {
    background-color: #007bff;
    color: white;
    font-weight: bold;
    position: sticky;
    top: 0;
    z-index: 2;
}

/* Centratura dei titoli e delle tabelle */
h2 {
    text-align: center;
}


.legend div {
    margin-bottom: 5px;
}

.loading {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.loading-text {
    margin-bottom: 1rem;
}

.alert {
    text-align: center;
}
</style>